import { useNavigate } from 'react-router-dom';
import { ParallaxBanner, Section } from './index.styled';

const JoinToday = ({ bannerImage, link, text }) => {
  const navigate = useNavigate();

  return (
    <Section>
      <ParallaxBanner
        layers={[
          {
            image: bannerImage,
            speed: 0,
          },
        ]}
      >
        <div className="caption copy-cap">
          <h1>{text}</h1>
        </div>
        <div className="caption" onClick={() => navigate('/contact')}>
          <h1 className="stroke">{text}</h1>
        </div>
      </ParallaxBanner>
    </Section>
  );
};

export default JoinToday;
